import { gql } from "@apollo/client";
import LoadedFilterFragment from "../../portal/hooks/LoadedFilterFragment";
import { ProductItemFragment } from "../../portal/components/products/ProductItem";

export const RootAssortmentsQuery = gql`
  query RootAssortments {
    assortments {
      _id
      texts {
        _id
        title
        subtitle
        slug
      }
      media {
        _id
        texts {
          _id
          title
        }
        file {
          _id
          url
        }
      }
    }
  }
`;

export const AssortmentProductsQuery = gql`
  query AssortmentProducts(
    $assortmentId: ID!
    $offset: Int
    $queryString: String
    $filterQuery: [FilterQueryInput!]
    $orderBy: SearchOrderBy
    $configuration: [ProductConfigurationParameterInput!]
  ) {
    assortment(assortmentId: $assortmentId) {
      _id
      searchProducts(
        queryString: $queryString
        filterQuery: $filterQuery
        orderBy: $orderBy
      ) {
        productsCount
        filteredProductsCount
        filters {
          ...LoadedFilterFragment
        }
        products(limit: 12, offset: $offset) {
          _id
          ...ProductItemFragment
          assortmentPaths {
            links {
              assortmentId
            }
          }
          ... on SimpleProduct {
            sku
            simulatedPrice(configuration: $configuration) {
              amount
              currency
            }
          }
        }
      }
    }
  }
  ${LoadedFilterFragment}
  ${ProductItemFragment}
`;

export const AssortmentChildrenQuery = gql`
  query AssortmentChildren($slug: String, $assortmentId: ID) {
    assortment(slug: $slug, assortmentId: $assortmentId) {
      _id
      texts {
        _id
        title
        subtitle
        slug
      }
      media {
        _id
        file {
          url
        }
      }
      children {
        _id
        texts {
          _id
          title
          subtitle
          slug
        }
        media {
          _id
          file {
            url
          }
        }
      }
    }
  }
`;

export const AssortmentQuery = gql`
  query Assortment($slug: String) {
    assortment(slug: $slug) {
      _id
      isActive
      tags
      texts {
        _id
        title
        subtitle
        slug
      }
      textsDe: texts(forceLocale: "de") {
        _id
        slug
      }
      textsFr: texts(forceLocale: "fr") {
        _id
        slug
      }
      textsIt: texts(forceLocale: "it") {
        _id
        slug
      }
      assortmentPaths {
        links {
          assortmentId
          assortmentTexts {
            _id
            title
            slug
          }
        }
      }
      media {
        _id
        texts {
          _id
          title
        }
        file {
          _id
          url
        }
      }
    }
  }
`;
